import { useState, useMemo, useRef, useCallback } from 'react';

export const usePagination = () => {
  const [page, setPage] = useState(0);
  const pageRef = useRef(0);

  const activePage = useMemo(() => page + 1, [page]);
  
  const changePage = useCallback((nextPage) => {
    setPage(nextPage);
    pageRef.current = nextPage;
  }, []);

  return {
    page,
    pageRef,
    activePage,
    changePage,
  }
}